/** @file The pending request to open an analysis in the auto-rig panel, kept until a mounted panel takes it. */
import { createStore } from 'zustand/vanilla';
import type { AutorigRequest } from './autorigTypes';

/** Module-level (W3-70): `request` is null once the panel took it; a newer request replaces an untaken one. */
export const autorigRequestStore = createStore<{ request: AutorigRequest | null }>()(() => ({ request: null }));
